export const phoneNumberRegex = /^\+?(\d[-, ]?){10,}$/;

type ConvertResult = {
    phoneNumber: string;
    status: 'already valid' | 'converted' | 'not convertible';
};

export function isValidE164PhoneNumber(phoneNumber: string): boolean {
    const E164RegEx = /^\+[1-9]\d{10,14}$/;

    return E164RegEx.test(phoneNumber);
}

export function convertNumberToE164(phoneNumber: string): ConvertResult {
    if (isValidE164PhoneNumber(phoneNumber)) {
        return { phoneNumber, status: 'already valid' };
    }

    const deleteDigitsWithinBrackets = phoneNumber.replace(/\(\d+\)/, '');
    const onlyDigits = deleteDigitsWithinBrackets.replace(/\D/g, '');
    let newPhoneNumber: string;
    if (onlyDigits.startsWith('00')) {
        // 00 is shorthand for +, so replace it.
        newPhoneNumber = `+${onlyDigits.substring(2)}`;
    } else if (onlyDigits.startsWith('0')) {
        // No country code present, number will be Dutch. Add +31, remove zero.
        newPhoneNumber = `+31${onlyDigits.substring(1)}`;
    } else {
        newPhoneNumber = `+${onlyDigits}`;
    }

    return isValidE164PhoneNumber(newPhoneNumber)
        ? { phoneNumber: newPhoneNumber, status: 'converted' }
        : { phoneNumber, status: 'not convertible' };
}

export function convertNumberToE164OrThrow(phoneNumber: string): ConvertResult {
    const converted = convertNumberToE164(phoneNumber);
    if (!isValidE164PhoneNumber(converted.phoneNumber)) {
        throw new Error('Phone number cannot be converted to E164 format');
    }

    return converted;
}
